import { extendTheme } from '@chakra-ui/react'

const colors = {
  brand: {
    500: '#6563DB',
  },
}

export default extendTheme({ colors })
